type OutageReporter = () => void;

let reporter: OutageReporter | undefined;

/** The server entry says what a report means for the request in hand; a browser has no entry, so it means nothing. */
export const setApiOutageReporter = (report: OutageReporter) => {
  reporter = report;
};

/**
 * A page could not be filled because the API did not answer. A visitor's browser asks again and
 * fills it, but a search engine would keep the empty page, so the server answers 503 with it and
 * the crawler comes back. Lives apart from the server entry because route files call it, and the
 * browser builds of those cannot bundle `node:async_hooks`.
 */
export const reportApiOutage = () => reporter?.();
